<form [formGroup]="form">
  <div class="flex flex-col w-full">
    <div class="flex flex-row items-baseline gap-4">
      <div class="flex flex-row flex-wrap gap-4 sm:flex-col w-1/2">
        <mat-card appearance="outlined" class="w-full sm:w-full mt-8" [ngClass]="{
              'bg-gray-600': sharedService.userTheme === 'dark',
              'bg-indigo-50': sharedService.userTheme === 'light'}">
          <mat-card-content>
            <div class="flex flex-col mt-4">

              <mat-form-field>
                <mat-label>PCA</mat-label>
                <input matInput formControlName="Pca">
              </mat-form-field>

              <mat-form-field>
                <mat-label>Index</mat-label>
                <input matInput formControlName="Index">
              </mat-form-field>

              <mat-form-field>
                <mat-label>Agency</mat-label>
                <input matInput formControlName="Agency">
              </mat-form-field>

            </div>
          </mat-card-content>
          <mat-card-content>
            <div class="flex flex-row items-baseline gap-4">
              <button type="button" mat-raised-button color="primary" (click)="savePcaIndexAgency()">
                Save
              </button>
              <button type="button" mat-raised-button (click)="getPcaIndexAgency()">
                Cancel
              </button>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</form>